import { API_URL } from "./Config";
import { PageResult } from "./Pagination";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync } from "./LicenceDetails";
import { formatDate } from "./DateUtils";

export interface ILicenceTransferRow {
  licencetransferid: string;
  casenumber: string;
  licenceid: string;
  status: string;
  proposedtransfereeorganisationid: string;
  proposedtransfereeorganisationname: string;
  transferrequestreason: string;
  validapplicationreceiveddate: string;
  licencetransferdate: string;
}

export interface ILicenceTransferDetails extends IDetailsResponse {
  licencetransferid: string;
  licenceid: string;
  casenumber: string;
  status: string;
  proposedtransfereeorganisationid: string;
  proposedtransfereeorganisationname: string;
  transferrequestreason: string;
  validapplicationreceiveddate: string;
  licencetransferdate: string;
  licence_regno: string;
}

export interface ILicenceTransfersList extends PageResult {
  list: ILicenceTransferRow[];
}

export interface ILicenceTransfersGridFilterValue {
  name: string;
  value: string;
}

export interface ILicenceTransfersGridFilterValueList {
  count: number;
  list: ILicenceTransfersGridFilterValue[];
}

export const GetLicenceTransfersByLicenceFetchUrl = (
  licence_id: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      params += `&${filterId}=${f.value}`;
    }
  }

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/LicenceTransfer/filteredlistbyla?lic_id=${licence_id}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-transfers`;
  }

  return url;
};

export async function GetLicenceTransfersStatusesAsync(): Promise<ILicenceTransfersGridFilterValueList> {
  let url = `${API_URL}/LicenceTransfer/ltstatusfilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-transfers-statuses`;
  }

  var response = await fetch(url);
  var body = <ILicenceTransfersGridFilterValueList>await response.json();
  body.list = body.list.map((item) => {
    return <ILicenceTransfersGridFilterValue>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export async function GetLicenceTransferDetailsAsync(
  licenceTransferId: string
): Promise<ILicenceTransferDetails> {
  var url = `${API_URL}/LicenceTransfer/byid?lt_id=${licenceTransferId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-transfers-details`;
  }

  var response = await fetch(url);
  var body = <ILicenceTransferDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  return <ILicenceTransferDetails>{
    response: response,
    licencetransferid: body.licencetransferid,
    licenceid: body.licenceid,
    casenumber: body.casenumber,
    status: body.status,
    proposedtransfereeorganisationid: body.proposedtransfereeorganisationid,
    proposedtransfereeorganisationname: body.proposedtransfereeorganisationname,
    transferrequestreason: body.transferrequestreason,
    validapplicationreceiveddate: formatDate(body.validapplicationreceiveddate),
    licencetransferdate: formatDate(body.licencetransferdate),
    licence_regno: licenceDetails.reg_no,
  };
}
